import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";

import Close from "Assets/images/close.svg";
import { areEqualShallow } from "Utils/areEqual";
import styles from "./styles";

interface Props {
  onClick: (e: any) => void;
  className?: string;
}
const CloseIcon: FC<Props> = memo(({ onClick, className = "" }: Props) => {
  const classes = createUseStyles(styles)();
  const click = (e: any) => {
    e.preventDefault();
    if (onClick) onClick(e);
  };
  return (
    <Close
      id="closeIcon"
      data-testid="closeIcon"
      className={`${classes.pointer} ${className}`}
      onClick={click}
    />
  );
}, areEqualShallow);
CloseIcon.defaultProps = {
  className: undefined,
};
export default CloseIcon;
